import React from 'react'

const SidebarIcon = ({ fill, variant }) => {
  const renderIcon = () => {
    if (variant === 'booking') {
      return (
        <svg
          width='14'
          height='14'
          viewBox='0 0 14 14'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_72325_57488)'>
            <path
              d='M0 11.082C0.00092625 11.8553 0.308514 12.5966 0.855295 13.1434C1.40208 13.6902 2.1434 13.9978 2.91667 13.9987H11.0833C11.8566 13.9978 12.5979 13.6902 13.1447 13.1434C13.6915 12.5966 13.9991 11.8553 14 11.082V5.83203H0V11.082ZM9.91667 8.45703C10.0897 8.45703 10.2589 8.50835 10.4028 8.6045C10.5467 8.70064 10.6588 8.8373 10.7251 8.99718C10.7913 9.15707 10.8086 9.333 10.7749 9.50274C10.7411 9.67247 10.6578 9.82838 10.5354 9.95075C10.413 10.0731 10.2571 10.1565 10.0874 10.1902C9.91764 10.224 9.7417 10.2067 9.58182 10.1404C9.42193 10.0742 9.28528 9.96205 9.18913 9.81816C9.09298 9.67426 9.04167 9.50509 9.04167 9.33203C9.04167 9.09997 9.13385 8.87741 9.29795 8.71331C9.46204 8.54922 9.6846 8.45703 9.91667 8.45703ZM7 8.45703C7.17306 8.45703 7.34223 8.50835 7.48612 8.6045C7.63002 8.70064 7.74217 8.8373 7.80839 8.99718C7.87462 9.15707 7.89195 9.333 7.85819 9.50274C7.82442 9.67247 7.74109 9.82838 7.61872 9.95075C7.49635 10.0731 7.34044 10.1565 7.1707 10.1902C7.00097 10.224 6.82504 10.2067 6.66515 10.1404C6.50527 10.0742 6.36861 9.96205 6.27246 9.81816C6.17632 9.67426 6.125 9.50509 6.125 9.33203C6.125 9.09997 6.21719 8.87741 6.38128 8.71331C6.54538 8.54922 6.76794 8.45703 7 8.45703ZM4.08333 8.45703C4.25639 8.45703 4.42556 8.50835 4.56946 8.6045C4.71335 8.70064 4.8255 8.8373 4.89173 8.99718C4.95795 9.15707 4.97528 9.333 4.94152 9.50274C4.90776 9.67247 4.82442 9.82838 4.70205 9.95075C4.57968 10.0731 4.42377 10.1565 4.25404 10.1902C4.0843 10.224 3.90837 10.2067 3.74849 10.1404C3.5886 10.0742 3.45194 9.96205 3.3558 9.81816C3.25965 9.67426 3.20833 9.50509 3.20833 9.33203C3.20833 9.09997 3.30052 8.87741 3.46461 8.71331C3.62871 8.54922 3.85127 8.45703 4.08333 8.45703Z'
              fill={fill}
            />
            <path
              d='M11.0833 1.16667H10.5V0.583333C10.5 0.428624 10.4385 0.280251 10.3291 0.170854C10.2197 0.0614582 10.0714 0 9.91667 0C9.76196 0 9.61358 0.0614582 9.50419 0.170854C9.39479 0.280251 9.33333 0.428624 9.33333 0.583333V1.16667H4.66667V0.583333C4.66667 0.428624 4.60521 0.280251 4.49581 0.170854C4.38642 0.0614582 4.23804 0 4.08333 0C3.92862 0 3.78025 0.0614582 3.67085 0.170854C3.56146 0.280251 3.5 0.428624 3.5 0.583333V1.16667H2.91667C2.1434 1.16759 1.40208 1.47518 0.855295 2.02196C0.308514 2.56874 0.00092625 3.31007 0 4.08333L0 4.66667H14V4.08333C13.9991 3.31007 13.6915 2.56874 13.1447 2.02196C12.5979 1.47518 11.8566 1.16759 11.0833 1.16667Z'
              fill={fill}
            />
          </g>
          <defs>
            <clipPath id='clip0_72325_57488'>
              <rect width='14' height='14' fill='white' />
            </clipPath>
          </defs>
        </svg>
      )
    }

    if (variant === 'chart') {
      return (
        <svg
          width='14'
          height='15'
          viewBox='0 0 14 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_72325_57368)'>
            <path
              d='M10.4869 7.5C8.55371 7.5 6.98688 9.06683 6.98688 11C6.98688 12.9332 8.55371 14.5 10.4869 14.5C12.42 14.5 13.9869 12.9332 13.9869 11C13.9869 9.06683 12.42 7.5 10.4869 7.5ZM12.4125 12.1287C12.3232 12.7587 11.7661 13.2167 11.1297 13.2167H10.9664V13.4547C10.9664 13.7096 10.7605 13.9167 10.5055 13.9167H10.4939C10.2395 13.9167 10.0336 13.709 10.0336 13.4547V13.2167H9.91696C9.50221 13.2167 9.13062 13.0271 8.88446 12.7307C8.64062 12.4367 8.84771 11.9922 9.22979 11.9922C9.36221 11.9922 9.52729 12.0547 9.61713 12.1521C9.69179 12.2332 9.79912 12.2839 9.91754 12.2839H11.1443C11.3065 12.2839 11.4546 12.1748 11.4861 12.0156C11.5229 11.8301 11.401 11.6568 11.223 11.6207L9.59496 11.2946C8.94629 11.1645 8.49363 10.5473 8.58871 9.87183C8.67737 9.24183 9.23504 8.78333 9.87146 8.78333H10.0348V8.55C10.0348 8.29217 10.2436 8.08333 10.5015 8.08333C10.7593 8.08333 10.9681 8.29217 10.9681 8.55V8.78333H11.0848C11.4995 8.78333 11.8711 8.97233 12.1173 9.26925C12.3611 9.56325 12.154 10.0077 11.772 10.0077C11.6395 10.0077 11.4745 9.94533 11.3846 9.84792C11.31 9.76683 11.2026 9.71608 11.0842 9.71608H9.85804C9.69588 9.71608 9.54771 9.82458 9.51563 9.98325C9.47829 10.1687 9.60079 10.3432 9.77754 10.3787L11.4062 10.7048C12.0549 10.8343 12.5081 11.4527 12.4125 12.1276V12.1287ZM14.0003 1.20933V4.07525C14.0003 4.52675 13.4543 4.75308 13.1346 4.434L12.2194 3.51875L10.6257 5.11242C9.75304 5.98508 8.33204 5.98567 7.45821 5.11242L5.88788 3.5415C5.69713 3.35075 5.38679 3.35075 5.19546 3.5415L1.49421 7.24392C1.32329 7.41483 1.09929 7.5 0.875292 7.5C0.651292 7.5 0.427292 7.41483 0.256375 7.24392C-0.0854583 6.90267 -0.0854583 6.34792 0.256375 6.00667L3.95879 2.30425C4.83146 1.431 6.25304 1.431 7.12571 2.30425L8.69604 3.87458C8.88737 4.06533 9.19713 4.06533 9.38904 3.87458L10.9827 2.28092L10.0675 1.36567C9.74779 1.046 9.97412 0.5 10.4262 0.5H13.2927C13.6841 0.5 14.002 0.817333 14.002 1.20933H14.0003ZM2.33363 9.54167V13.625C2.33363 14.108 1.94221 14.5 1.45863 14.5C0.975042 14.5 0.583625 14.108 0.583625 13.625V9.54167C0.583625 9.05867 0.975042 8.66667 1.45863 8.66667C1.94221 8.66667 2.33363 9.05867 2.33363 9.54167ZM5.25029 7.20833V13.625C5.25029 14.108 4.85888 14.5 4.37529 14.5C3.89171 14.5 3.50029 14.108 3.50029 13.625V7.20833C3.50029 6.72475 3.89171 6.33333 4.37529 6.33333C4.85888 6.33333 5.25029 6.72475 5.25029 7.20833Z'
              fill={fill}
            />
          </g>
          <defs>
            <clipPath id='clip0_72325_57368'>
              <rect
                width='14'
                height='14'
                fill='white'
                transform='translate(0 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      )
    }

    if (variant === 'client') {
      return (
        <svg
          width='14'
          height='15'
          viewBox='0 0 14 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M9.09565 2.26586C8.56354 1.69137 7.82034 1.375 7.00003 1.375C6.17534 1.375 5.42967 1.68945 4.90003 2.26039C4.36464 2.83762 4.10378 3.62211 4.16503 4.46922C4.28643 6.14047 5.55819 7.5 7.00003 7.5C8.44186 7.5 9.71143 6.14074 9.83475 4.46976C9.89682 3.63031 9.63432 2.84746 9.09565 2.26586Z'
            fill={fill}
          />
          <path
            d='M11.8127 13.624H2.18766C2.06167 13.6257 1.93691 13.5992 1.82244 13.5465C1.70798 13.4939 1.60668 13.4164 1.52594 13.3197C1.3482 13.1072 1.27656 12.8171 1.32961 12.5237C1.56039 11.2435 2.28062 10.168 3.41266 9.41309C4.41836 8.74289 5.6923 8.37402 7.00015 8.37402C8.30801 8.37402 9.58195 8.74316 10.5877 9.41309C11.7197 10.1678 12.4399 11.2432 12.6707 12.5234C12.7237 12.8168 12.6521 13.107 12.4744 13.3194C12.3937 13.4162 12.2924 13.4937 12.1779 13.5464C12.0634 13.5991 11.9387 13.6256 11.8127 13.624V13.624Z'
            fill={fill}
          />
        </svg>
      )
    }

    if (variant === 'company') {
      return (
        <svg
          width='14'
          height='15'
          viewBox='0 0 14 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_72325_57338)'>
            <path
              d='M6.41667 0.5H1.75C1.28587 0.5 0.840752 0.684374 0.512563 1.01256C0.184374 1.34075 0 1.78587 0 2.25L0 14.5H8.16667V2.25C8.16667 1.78587 7.98229 1.34075 7.6541 1.01256C7.32591 0.684374 6.8808 0.5 6.41667 0.5ZM3.5 11.5833H1.75V10.4167H3.5V11.5833ZM3.5 9.25H1.75V8.08333H3.5V9.25ZM3.5 6.91667H1.75V5.75H3.5V6.91667ZM3.5 4.58333H1.75V3.41667H3.5V4.58333ZM6.41667 11.5833H4.66667V10.4167H6.41667V11.5833ZM6.41667 9.25H4.66667V8.08333H6.41667V9.25ZM6.41667 6.91667H4.66667V5.75H6.41667V6.91667ZM6.41667 4.58333H4.66667V3.41667H6.41667V4.58333ZM12.25 3.41667H9.33333V14.5H14V5.16667C14 4.70254 13.8156 4.25742 13.4874 3.92923C13.1592 3.60104 12.7141 3.41667 12.25 3.41667ZM12.25 11.5833H11.0833V10.4167H12.25V11.5833ZM12.25 9.25H11.0833V8.08333H12.25V9.25ZM12.25 6.91667H11.0833V5.75H12.25V6.91667Z'
              fill={fill}
            />
          </g>
          <defs>
            <clipPath id='clip0_72325_57338'>
              <rect
                width='14'
                height='14'
                fill='white'
                transform='translate(0 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      )
    }

    if (variant === 'crm') {
      return (
        <svg
          width='14'
          height='14'
          viewBox='0 0 14 14'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M2.84375 13.5625H1.96875C1.7947 13.5625 1.62778 13.4934 1.50471 13.3703C1.38164 13.2472 1.3125 13.0803 1.3125 12.9062V8.96875C1.3125 8.7947 1.38164 8.62778 1.50471 8.50471C1.62778 8.38164 1.7947 8.3125 1.96875 8.3125H2.84375C3.0178 8.3125 3.18472 8.38164 3.30779 8.50471C3.43086 8.62778 3.5 8.7947 3.5 8.96875V12.9062C3.5 13.0803 3.43086 13.2472 3.30779 13.3703C3.18472 13.4934 3.0178 13.5625 2.84375 13.5625V13.5625Z'
            fill={fill}
          />
          <path
            d='M8.96875 13.5625H8.09375C7.9197 13.5625 7.75278 13.4934 7.62971 13.3703C7.50664 13.2472 7.4375 13.0803 7.4375 12.9062V6.34375C7.4375 6.1697 7.50664 6.00278 7.62971 5.87971C7.75278 5.75664 7.9197 5.6875 8.09375 5.6875H8.96875C9.1428 5.6875 9.30972 5.75664 9.43279 5.87971C9.55586 6.00278 9.625 6.1697 9.625 6.34375V12.9062C9.625 13.0803 9.55586 13.2472 9.43279 13.3703C9.30972 13.4934 9.1428 13.5625 8.96875 13.5625V13.5625Z'
            fill={fill}
          />
          <path
            d='M12.0312 13.5625H11.1562C10.9822 13.5625 10.8153 13.4934 10.6922 13.3703C10.5691 13.2472 10.5 13.0803 10.5 12.9062V3.28125C10.5 3.1072 10.5691 2.94028 10.6922 2.81721C10.8153 2.69414 10.9822 2.625 11.1562 2.625H12.0312C12.2053 2.625 12.3722 2.69414 12.4953 2.81721C12.6184 2.94028 12.6875 3.1072 12.6875 3.28125V12.9062C12.6875 13.0803 12.6184 13.2472 12.4953 13.3703C12.3722 13.4934 12.2053 13.5625 12.0312 13.5625V13.5625Z'
            fill={fill}
          />
          <path
            d='M5.90625 13.5625H5.03125C4.8572 13.5625 4.69028 13.4934 4.56721 13.3703C4.44414 13.2472 4.375 13.0803 4.375 12.9062V1.09375C4.375 0.919702 4.44414 0.752782 4.56721 0.629711C4.69028 0.50664 4.8572 0.4375 5.03125 0.4375H5.90625C6.0803 0.4375 6.24722 0.50664 6.37029 0.629711C6.49336 0.752782 6.5625 0.919702 6.5625 1.09375V12.9062C6.5625 13.0803 6.49336 13.2472 6.37029 13.3703C6.24722 13.4934 6.0803 13.5625 5.90625 13.5625V13.5625Z'
            fill={fill}
          />
        </svg>
      )
    }

    if (variant === 'ebooks') {
      return (
        <svg
          width='14'
          height='15'
          viewBox='0 0 14 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_72325_57505)'>
            <path
              d='M7 5.75C5.55275 5.75 4.375 4.57225 4.375 3.125C4.375 1.67775 5.55275 0.5 7 0.5C8.44725 0.5 9.625 1.67775 9.625 3.125C9.625 4.57225 8.44725 5.75 7 5.75ZM13.3712 6.14725C12.971 5.81358 12.4501 5.67592 11.9035 5.77625L9.499 6.36133C8.38892 6.56317 7.58333 7.52858 7.58333 8.65733V13.2085L7 13.3147L6.41667 13.2085V8.65733C6.41667 7.52858 5.61108 6.56375 4.53425 6.36892L2.06267 5.76925C1.54875 5.67475 1.02783 5.81417 0.628833 6.14725C0.228667 6.48092 0 6.97033 0 7.49067V13.2272L7 14.5L14 13.2272V7.49067C14 6.97033 13.7708 6.48092 13.3712 6.14725Z'
              fill={fill}
            />
          </g>
          <defs>
            <clipPath id='clip0_72325_57505'>
              <rect
                width='14'
                height='14'
                fill='white'
                transform='translate(0 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      )
    }

    if (variant === 'employees') {
      return (
        <svg
          width='14'
          height='15'
          viewBox='0 0 14 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_72325_57333)'>
            <path
              d='M7 9.83333C6.53851 9.83333 6.08738 9.69649 5.70367 9.4401C5.31995 9.18371 5.02088 8.81929 4.84428 8.39293C4.66768 7.96657 4.62147 7.49741 4.7115 7.04479C4.80153 6.59217 5.02376 6.17641 5.35008 5.85009C5.67641 5.52376 6.09217 5.30153 6.54479 5.2115C6.99741 5.12147 7.46657 5.16768 7.89293 5.34428C8.31929 5.52089 8.68371 5.81996 8.94009 6.20367C9.19649 6.58739 9.33333 7.03851 9.33333 7.5C9.33333 8.11884 9.0875 8.71233 8.64992 9.14992C8.21233 9.5875 7.61884 9.83333 7 9.83333ZM3.31508 9.83333H0.583333C0.428624 9.83333 0.280251 9.77188 0.170854 9.66248C0.0614582 9.55308 0 9.40471 0 9.25C0.00552757 8.4124 0.310173 7.60433 0.858991 6.97155C1.40781 6.33877 2.16467 5.92292 2.99308 5.799C3.08935 5.78551 3.18745 5.7963 3.27849 5.83037C3.36952 5.86444 3.4506 5.92072 3.51436 5.99409C3.57811 6.06747 3.62252 6.15561 3.64354 6.25051C3.66457 6.34541 3.66155 6.44407 3.63475 6.5375C3.54536 6.85052 3.5 7.17447 3.5 7.5C3.50017 8.01903 3.61699 8.53137 3.84183 8.99917C3.88412 9.08796 3.90328 9.186 3.89752 9.28418C3.89175 9.38236 3.86126 9.47749 3.80888 9.56072C3.75649 9.64396 3.68391 9.71259 3.59789 9.76026C3.51186 9.80792 3.41518 9.83306 3.31683 9.83333H3.31508ZM9.91667 14.5H4.08333C3.92862 14.5 3.78025 14.4385 3.67085 14.3291C3.56146 14.2198 3.5 14.0714 3.5 13.9167C3.5 12.9884 3.86875 12.0982 4.52513 11.4418C5.1815 10.7854 6.07174 10.4167 7 10.4167C7.92826 10.4167 8.8185 10.7854 9.47487 11.4418C10.1313 12.0982 10.5 12.9884 10.5 13.9167C10.5 14.0714 10.4385 14.2198 10.3291 14.3291C10.2197 14.4385 10.0714 14.5 9.91667 14.5ZM10.5 5.16667C10.0385 5.16667 9.58738 5.02982 9.20367 4.77343C8.81995 4.51704 8.52089 4.15262 8.34428 3.72626C8.16768 3.2999 8.12147 2.83075 8.2115 2.37812C8.30153 1.9255 8.52376 1.50974 8.85008 1.18342C9.17641 0.857096 9.59217 0.634868 10.0448 0.544835C10.4974 0.454803 10.9666 0.501011 11.3929 0.677615C11.8193 0.85422 12.1837 1.15329 12.4401 1.537C12.6965 1.92072 12.8333 2.37184 12.8333 2.83333C12.8333 3.45217 12.5875 4.04567 12.1499 4.48325C11.7123 4.92084 11.1188 5.16667 10.5 5.16667ZM3.5 5.16667C3.03851 5.16667 2.58738 5.02982 2.20367 4.77343C1.81995 4.51704 1.52089 4.15262 1.34428 3.72626C1.16768 3.2999 1.12147 2.83075 1.2115 2.37812C1.30153 1.9255 1.52376 1.50974 1.85008 1.18342C2.17641 0.857096 2.59217 0.634868 3.04479 0.544835C3.49741 0.454803 3.96657 0.501011 4.39293 0.677615C4.81929 0.85422 5.18371 1.15329 5.4401 1.537C5.69649 1.92072 5.83333 2.37184 5.83333 2.83333C5.83333 3.45217 5.5875 4.04567 5.14992 4.48325C4.71233 4.92084 4.11884 5.16667 3.5 5.16667ZM13.4167 9.83333H10.6849C10.5866 9.83306 10.4899 9.80792 10.4039 9.76026C10.3178 9.71259 10.2453 9.64396 10.1929 9.56072C10.1405 9.47749 10.11 9.38236 10.1042 9.28418C10.0985 9.186 10.1176 9.08796 10.1599 8.99917C10.3842 8.53123 10.5004 8.01889 10.5 7.5C10.499 7.17433 10.4527 6.85038 10.3623 6.5375C10.3354 6.4438 10.3323 6.34484 10.3535 6.24966C10.3747 6.15448 10.4193 6.06613 10.4835 5.99267C10.5476 5.91922 10.6291 5.863 10.7205 5.82917C10.812 5.79534 10.9104 5.78497 11.0069 5.799C11.8353 5.92292 12.5922 6.33877 13.141 6.97155C13.6898 7.60433 13.9945 8.4124 14 9.25C14 9.40471 13.9385 9.55308 13.8291 9.66248C13.7197 9.77188 13.5714 9.83333 13.4167 9.83333Z'
              fill={fill}
            />
          </g>
          <defs>
            <clipPath id='clip0_72325_57333'>
              <rect
                width='14'
                height='14'
                fill='white'
                transform='translate(0 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      )
    }

    if (variant === 'fitness') {
      return (
        <svg
          width='14'
          height='15'
          viewBox='0 0 14 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_72325_57363)'>
            <path
              d='M13.4869 4.65442L12.0787 3.24567L13.2454 2.079L12.4205 1.25417L11.2539 2.42083L9.84571 1.01267C9.6832 0.850134 9.49027 0.721203 9.27793 0.633239C9.06559 0.545275 8.83801 0.5 8.60817 0.5C8.37833 0.5 8.15074 0.545275 7.9384 0.633239C7.72606 0.721203 7.53313 0.850134 7.37063 1.01267L5.72096 2.66233L8.36638 5.30833L4.80804 8.86667L2.16204 6.22125L0.512376 7.87092C0.184302 8.19909 0 8.64413 0 9.10817C0 9.5722 0.184302 10.0172 0.512376 10.3454L1.92054 11.7542L0.753876 12.9208L1.57871 13.7457L2.74538 12.579L4.15354 13.9872C4.31605 14.1497 4.50898 14.2786 4.72132 14.3666C4.93366 14.4546 5.16125 14.4998 5.39109 14.4998C5.62092 14.4998 5.84851 14.4546 6.06085 14.3666C6.27319 14.2786 6.46612 14.1497 6.62863 13.9872L8.27829 12.3375L5.63288 9.6915L9.19121 6.13317L11.8366 8.77858L13.4863 7.12892C13.8144 6.80074 13.9987 6.3557 13.9987 5.89167C13.9987 5.42763 13.815 4.98259 13.4869 4.65442Z'
              fill={fill}
            />
          </g>
          <defs>
            <clipPath id='clip0_72325_57363'>
              <rect
                width='14'
                height='14'
                fill='white'
                transform='translate(0 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      )
    }

    if (variant === 'group_settings') {
      return (
        <svg
          width='14'
          height='15'
          viewBox='0 0 14 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_72325_57343)'>
            <path
              d='M4.66667 7.5C6.59692 7.5 8.16667 5.93025 8.16667 4C8.16667 2.06975 6.59692 0.5 4.66667 0.5C2.73642 0.5 1.16667 2.06975 1.16667 4C1.16667 5.93025 2.73642 7.5 4.66667 7.5ZM13.2393 11.6615L12.6712 11.3337C12.768 11.0437 12.8333 10.7392 12.8333 10.4167C12.8333 10.0941 12.7686 9.78958 12.6712 9.49967L13.2393 9.17183C13.5182 9.01083 13.6138 8.65383 13.4528 8.375C13.2912 8.09558 12.9348 7.99992 12.656 8.1615L12.0884 8.48933C11.6772 8.02617 11.1294 7.68725 10.5 7.5595V6.91725C10.5 6.59525 10.2387 6.33392 9.91667 6.33392C9.59467 6.33392 9.33333 6.59525 9.33333 6.91725V7.5595C8.70392 7.68783 8.15617 8.02675 7.74492 8.48933L7.17733 8.1615C6.89675 7.99992 6.5415 8.09558 6.3805 8.375C6.2195 8.65442 6.31517 9.01083 6.594 9.17183L7.16217 9.49967C7.06533 9.78958 7 10.0941 7 10.4167C7 10.7392 7.06475 11.0437 7.16217 11.3337L6.594 11.6615C6.31517 11.8225 6.2195 12.1795 6.3805 12.4583C6.489 12.6456 6.68442 12.75 6.88625 12.75C6.98483 12.75 7.08517 12.7249 7.17733 12.6718L7.74492 12.344C8.15617 12.8072 8.70392 13.1461 9.33333 13.2738V13.9161C9.33333 14.2381 9.59467 14.4994 9.91667 14.4994C10.2387 14.4994 10.5 14.2381 10.5 13.9161V13.2738C11.1294 13.1455 11.6772 12.8066 12.0884 12.344L12.656 12.6718C12.7482 12.7249 12.8485 12.75 12.9471 12.75C13.1489 12.75 13.3449 12.6456 13.4528 12.4583C13.6138 12.1789 13.5182 11.8225 13.2393 11.6615ZM9.91667 11.2917C9.43425 11.2917 9.04167 10.8991 9.04167 10.4167C9.04167 9.93425 9.43425 9.54167 9.91667 9.54167C10.3991 9.54167 10.7917 9.93425 10.7917 10.4167C10.7917 10.8991 10.3991 11.2917 9.91667 11.2917ZM4.95833 10.4167C4.95833 10.0964 4.99042 9.7715 5.05458 9.4495C5.09308 9.25525 5.03008 9.05517 4.88833 8.9175C4.74658 8.77983 4.54475 8.72383 4.35167 8.76758C1.87075 9.33692 0 11.5507 0 13.9167C0 14.2387 0.261333 14.5 0.583333 14.5H5.62158C5.84675 14.5 6.05208 14.3705 6.14833 14.1669C6.24517 13.9633 6.216 13.7224 6.07367 13.548C5.35442 12.6666 4.95833 11.5547 4.95833 10.4167Z'
              fill={fill}
            />
          </g>
          <defs>
            <clipPath id='clip0_72325_57343'>
              <rect
                width='14'
                height='14'
                fill='white'
                transform='translate(0 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      )
    }

    if (variant === 'invoices') {
      return (
        <svg
          width='14'
          height='15'
          viewBox='0 0 14 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_72325_57355)'>
            <path
              d='M14 11.5833C14 12.5482 13.2148 13.3333 12.25 13.3333V13.9167C12.25 14.2387 11.9892 14.5 11.6667 14.5C11.3441 14.5 11.0833 14.2387 11.0833 13.9167V13.3333H10.927C10.3046 13.3333 9.72358 12.9985 9.4115 12.4589C9.24992 12.1801 9.34558 11.8237 9.62383 11.6621C9.90383 11.5005 10.2603 11.5962 10.4207 11.875C10.5251 12.0547 10.7188 12.1667 10.9264 12.1667H12.2494C12.5714 12.1667 12.8328 11.9047 12.8328 11.5833C12.8328 11.3628 12.6747 11.1762 12.4571 11.14L10.6832 10.8442C9.90033 10.7142 9.33275 10.0433 9.33275 9.25C9.33275 8.28517 10.1179 7.5 11.0828 7.5V6.91667C11.0828 6.59467 11.3435 6.33333 11.6661 6.33333C11.9887 6.33333 12.2494 6.59467 12.2494 6.91667V7.5H12.4057C13.0282 7.5 13.6092 7.83542 13.9212 8.375C14.0828 8.65383 13.9872 9.01025 13.7089 9.17183C13.4283 9.33283 13.0725 9.23717 12.9121 8.95892C12.8077 8.77867 12.614 8.66725 12.4063 8.66725H11.0833C10.7613 8.66725 10.5 8.92917 10.5 9.25058C10.5 9.47108 10.6581 9.65775 10.8757 9.69392L12.6496 9.98967C13.4324 10.1197 14 10.79 14 11.5833ZM7.58333 5.16667H11.3983C11.1959 4.63408 10.885 4.14408 10.4702 3.72933L8.43792 1.69583C8.02258 1.28108 7.53258 0.970167 7 0.768333V4.58333C7 4.90475 7.26133 5.16667 7.58333 5.16667ZM9.84025 14.2882C9.50308 14.4247 9.13558 14.5 8.75 14.5H2.91667C1.30842 14.5 0 13.1916 0 11.5833V3.41667C0 1.80842 1.30842 0.5 2.91667 0.5H5.55042C5.6455 0.5 5.73942 0.507583 5.83333 0.514V4.58333C5.83333 5.54817 6.6185 6.33333 7.58333 6.33333H10.017C9.99075 6.40742 9.96917 6.48325 9.95283 6.56142C9.23533 6.86417 8.66308 7.44692 8.37317 8.17142C8.21742 8.11483 8.04942 8.08333 7.87442 8.08333H3.79167C2.98783 8.08333 2.33333 8.73783 2.33333 9.54167V10.7083C2.33333 11.5122 2.98783 12.1667 3.79167 12.1667H7.875C7.97475 12.1667 8.07217 12.1567 8.16608 12.1375C8.16025 12.4525 8.24017 12.764 8.40175 13.0428C8.73192 13.6145 9.24408 14.0485 9.84025 14.2888V14.2882ZM2.33333 4C2.33333 4.322 2.59467 4.58333 2.91667 4.58333H4.08333C4.40533 4.58333 4.66667 4.322 4.66667 4C4.66667 3.678 4.40533 3.41667 4.08333 3.41667H2.91667C2.59467 3.41667 2.33333 3.678 2.33333 4ZM2.33333 6.33333C2.33333 6.65533 2.59467 6.91667 2.91667 6.91667H4.08333C4.40533 6.91667 4.66667 6.65533 4.66667 6.33333C4.66667 6.01133 4.40533 5.75 4.08333 5.75H2.91667C2.59467 5.75 2.33333 6.01133 2.33333 6.33333ZM3.79167 9.25C3.63067 9.25 3.5 9.38067 3.5 9.54167V10.7083C3.5 10.8693 3.63067 11 3.79167 11H7.875C8.036 11 8.16667 10.8693 8.16667 10.7083V9.54167C8.16667 9.38067 8.036 9.25 7.875 9.25H3.79167Z'
              fill={fill}
            />
          </g>
          <defs>
            <clipPath id='clip0_72325_57355'>
              <rect
                width='14'
                height='14'
                fill='white'
                transform='translate(0 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      )
    }

    if (variant === 'learning') {
      return (
        <svg
          width='14'
          height='15'
          viewBox='0 0 14 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M13.9999 5.44559V12.1656C13.9999 12.3203 13.9385 12.4687 13.8291 12.5781C13.7197 12.6875 13.5713 12.7489 13.4166 12.7489C13.2619 12.7489 13.1135 12.6875 13.0041 12.5781C12.8947 12.4687 12.8333 12.3203 12.8333 12.1656V7.35426L8.51662 9.41692C8.06147 9.68558 7.54187 9.82551 7.01337 9.82176C6.45911 9.82262 5.91493 9.67367 5.43837 9.39067L1.13336 7.34142C0.794962 7.15945 0.511421 6.89024 0.312161 6.56172C0.1129 6.2332 0.00518192 5.85734 0.00018233 5.47314C-0.00481726 5.08895 0.0930842 4.71042 0.283728 4.37682C0.474372 4.04323 0.750812 3.76673 1.08436 3.57601C1.10011 3.56668 1.11703 3.55792 1.13336 3.54976L5.48328 1.47426C5.9529 1.20456 6.48589 1.06483 7.02743 1.06945C7.56896 1.07406 8.09949 1.22285 8.56445 1.50051L12.8665 3.54976C13.206 3.73758 13.4897 4.01193 13.6888 4.34492C13.8878 4.6779 13.9952 5.05766 13.9999 5.44559ZM7.01278 10.9873C6.26645 10.9889 5.53294 10.7933 4.88653 10.4203L2.33328 9.20167V10.7767C2.33363 11.3994 2.53299 12.0057 2.90228 12.5071C3.27157 13.0085 3.79144 13.3788 4.38603 13.5638C5.23556 13.8078 6.11616 13.9263 6.99995 13.9156C7.88385 13.9255 8.76445 13.8062 9.61387 13.5615C10.2085 13.3764 10.7283 13.0062 11.0976 12.5048C11.4669 12.0034 11.6663 11.3971 11.6666 10.7743V9.20459L9.06553 10.4471C8.44116 10.8058 7.73285 10.9926 7.01278 10.9884V10.9873Z'
            fill={fill}
          />
        </svg>
      )
    }

    if (variant === 'tests') {
      return (
        <svg
          width='14'
          height='15'
          viewBox='0 0 14 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_72325_57500)'>
            <path
              d='M11.3248 3.41667H8.75V0.841833L11.3248 3.41667ZM13.1612 14.486L11.3593 12.6841C10.787 13.0912 10.0893 13.3333 9.33333 13.3333C7.40017 13.3333 5.83333 11.7665 5.83333 9.83333C5.83333 7.90017 7.40017 6.33333 9.33333 6.33333C11.2665 6.33333 12.8333 7.90017 12.8333 9.83333C12.8333 10.5893 12.5913 11.287 12.1841 11.8592L13.986 13.6612L13.1612 14.486ZM9.772 11.2561L11.8761 9.10008L11.0606 8.26592L8.95242 10.426L7.65975 9.08375L6.85067 9.92433L8.1235 11.2473C8.57033 11.6936 9.33625 11.6924 9.77025 11.2584L9.772 11.2561ZM5.01025 11.5828H2.33333V10.4161H4.70692C4.683 10.2247 4.66667 10.0305 4.66667 9.83275C4.66667 9.635 4.683 9.44075 4.70692 9.24942H2.33333V8.08275H5.01025C5.18233 7.65925 5.41392 7.26725 5.69625 6.91608H2.33333V5.74942H7.07933C7.74842 5.37842 8.51608 5.16608 9.33333 5.16608C10.1838 5.16608 10.9795 5.39825 11.6667 5.79725V4.58275H7.58333V0.5H1.75C0.783417 0.5 0 1.28342 0 2.25V14.5H9.33333C7.37917 14.5 5.70442 13.2907 5.01025 11.5828Z'
              fill={fill}
            />
          </g>
          <defs>
            <clipPath id='clip0_72325_57500'>
              <rect
                width='14'
                height='14'
                fill='white'
                transform='translate(0 0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      )
    }

    if (variant === 'widgets') {
      return (
        <svg
          width='14'
          height='15'
          viewBox='0 0 14 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M4.375 0.5C4.14294 0.5 3.92038 0.605357 3.75628 0.792893C3.59219 0.98043 3.5 1.23478 3.5 1.5C3.5 1.76522 3.59219 2.01957 3.75628 2.20711C3.92038 2.39464 4.14294 2.5 4.375 2.5H9.625C9.85706 2.5 10.0796 2.39464 10.2437 2.20711C10.4078 2.01957 10.5 1.76522 10.5 1.5C10.5 1.23478 10.4078 0.98043 10.2437 0.792893C10.0796 0.605357 9.85706 0.5 9.625 0.5H4.375ZM1.75 4.5C1.75 4.23478 1.84219 3.98043 2.00628 3.79289C2.17038 3.60536 2.39294 3.5 2.625 3.5H11.375C11.6071 3.5 11.8296 3.60536 11.9937 3.79289C12.1578 3.98043 12.25 4.23478 12.25 4.5C12.25 4.76522 12.1578 5.01957 11.9937 5.20711C11.8296 5.39464 11.6071 5.5 11.375 5.5H2.625C2.39294 5.5 2.17038 5.39464 2.00628 5.20711C1.84219 5.01957 1.75 4.76522 1.75 4.5ZM0 8.5C0 7.96957 0.184374 7.46086 0.512563 7.08579C0.840752 6.71071 1.28587 6.5 1.75 6.5H12.25C12.7141 6.5 13.1592 6.71071 13.4874 7.08579C13.8156 7.46086 14 7.96957 14 8.5V12.5C14 13.0304 13.8156 13.5391 13.4874 13.9142C13.1592 14.2893 12.7141 14.5 12.25 14.5H1.75C1.28587 14.5 0.840752 14.2893 0.512563 13.9142C0.184374 13.5391 0 13.0304 0 12.5V8.5Z'
            fill={fill}
          />
        </svg>
      )
    }

    return null
  }

  return renderIcon()
}

export default SidebarIcon
